
import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Contacto inicial',
    description: 'Llámanos o escríbenos por WhatsApp. Te atendemos de inmediato y sin compromiso.',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Valoración y presupuesto',
    description: 'Visitamos el espacio si es necesario y te entregamos un presupuesto detallado y transparente.',
  },
  {
    number: '03',
    icon: 'ri-calendar-check-line',
    title: 'Planificación',
    description: 'Acordamos fecha y hora según tu disponibilidad. Nos adaptamos a tus necesidades.',
  },
  {
    number: '04',
    icon: 'ri-truck-line',
    title: 'Ejecución del servicio',
    description: 'Nuestro equipo profesional realiza el vaciado y limpieza de forma rápida y eficiente.',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-dark mb-4 sm:mb-6">
            ¿Cómo trabajamos?
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Nuestro proceso de <strong>vaciado de pisos y locales en Vic</strong> es simple, rápido y transparente. Desde el primer contacto hasta la entrega final, te acompañamos en cada paso. Descubre todos nuestros <Link to="/servicios" className="text-primary hover:text-red-700 font-semibold">servicios especializados</Link>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <article
              key={index}
              className="relative bg-white rounded-lg p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-100"
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-primary rounded-full text-white font-bold text-lg sm:text-xl shadow-lg flex-shrink-0">
                {step.number}
              </div>
              <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-secondary/20 rounded-lg mb-4 sm:mb-6 flex-shrink-0">
                <i className={`${step.icon} text-3xl sm:text-4xl text-primary`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-dark mb-3 sm:mb-4 break-words">
                {step.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed break-words">
                {step.description}
              </p>
            </article>
          ))}
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <p className="text-sm sm:text-base text-gray-600 mb-6 sm:mb-8 leading-relaxed">
            ¿Tienes dudas sobre nuestro proceso? Consulta nuestras <Link to="/faq" className="text-primary hover:text-red-700 font-semibold">preguntas frecuentes</Link> o <Link to="/contacto" className="text-primary hover:text-red-700 font-semibold">contáctanos directamente</Link>.
          </p>
        </div>
      </div>
    </section>
  );
}
